import styles from './index.module.css'

import { IoClose } from '@react-icons/all-files/io5/IoClose'
import React from 'react'

import type { LinkInfo, LinkInfoProvider } from 'types/search-page'

import AppleMusicLogo from 'assets/icons/apple-music-logo.svg'
import SpotifyLogo from 'assets/icons/spotify-logo.svg'
import YoutubeLogo from 'assets/icons/youtube-logo.svg'
import DiscoLogo from 'assets/logo/brand-mark-black.svg'

import { Button, Flex } from 'components/ds'

type Props = {
  linkInfo: LinkInfo
  onDismiss: () => void
}

const providerIcons: Record<
  LinkInfoProvider,
  React.FC<{ className?: string }>
> = {
  spotify: SpotifyLogo,
  youtube: YoutubeLogo,
  applemusic: AppleMusicLogo,
  disco: DiscoLogo,
}

const LinkPreview = ({ linkInfo, onDismiss }: Props): React.ReactNode => {
  const ProviderIcon = providerIcons[linkInfo.provider]

  return (
    <Flex className={styles.linkPreviewContainer}>
      {ProviderIcon && (
        <span className={styles.providerIcon}>
          <ProviderIcon />
        </span>
      )}
      <span className={styles.titleText}>{linkInfo.title}</span>
      <Button
        variant="ghost"
        size="1"
        className={styles.dismissButton}
        onClick={onDismiss}
        aria-label="Dismiss link preview"
      >
        <IoClose size={14} />
      </Button>
    </Flex>
  )
}

export default LinkPreview
